import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import StaticTabContent from 'components/tab/StaticTabContent/StaticTabContent';
import { maybeFormatPrefixedMessage } from 'utils/i18nUtils';

import ExplainTab from './patterns/ExplainTab/ExplainTab';

const generateTabs = formatMessage => [
  {
    tabLabel: formatMessage('EARN.LABEL'),
    component: (
      <ExplainTab
        key={formatMessage('EARN.LABEL')}
        title={formatMessage('EARN.TITLE')}
        copy={formatMessage('EARN.TEXT')}
        videoId="Kl1beK9RReA"
      />
    ),
  },
  {
    tabLabel: formatMessage('REDEEM.LABEL'),
    component: (
      <ExplainTab
        key={formatMessage('REDEEM.LABEL')}
        title={formatMessage('REDEEM.TITLE')}
        copy={formatMessage('REDEEM.TEXT')}
        videoId="UiDWR5T4GPI"
      />
    ),
  },
];

function SectionTabsExplain() {
  const intl = useIntl();
  const formatMessage = maybeFormatPrefixedMessage(intl, 'REWARDS.TABS');
  const tabs = useMemo(() => generateTabs(formatMessage), []);

  return (
    <Section>
      <Block blockWidth="100%">
        <StaticTabContent content={tabs} />
      </Block>
    </Section>
  );
}

export default React.memo(SectionTabsExplain);
